import { Bar } from 'react-chartjs-2'
import { useIntl } from 'react-intl'
import { ChartConfiguration } from 'chart.js'

import { CHART_FONT } from 'Constants/charts'

import {
  EARLY_UPGRADE_CHART_BACKGROUND_COLOR,
  EARLY_UPGRADE_CHART_BORDER_COLOR,
  EARLY_UPGRADE_CHART_FONT_COLOR,
} from './EarlyUpgradeEligibleRentalChart.constants'
import { EarlyUpgradeEligibleRentalChartProps } from './EarlyUpgradeEligibleRentalChart.types'

export const EarlyUpgradeEligibleRentalChart = (
  props: EarlyUpgradeEligibleRentalChartProps,
) => {
  const { data, labels } = props

  const intl = useIntl()

  const config: ChartConfiguration<'bar'> = {
    data: {
      datasets: [
        {
          backgroundColor: EARLY_UPGRADE_CHART_BACKGROUND_COLOR,
          borderColor: EARLY_UPGRADE_CHART_BORDER_COLOR,
          borderRadius: 4,
          borderSkipped: false,
          borderWidth: 1,
          data,
          label: intl.formatMessage({ id: 'Total' }),
        },
      ],
      labels,
    },
    options: {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          bodyFont: CHART_FONT,
          displayColors: false,
          titleFont: CHART_FONT,
        },
      },
      responsive: true,
      scales: {
        x: {
          border: {
            display: false,
          },
          grid: {
            display: false,
          },
          ticks: {
            color: EARLY_UPGRADE_CHART_FONT_COLOR,
            font: CHART_FONT,
          },
        },
        y: {
          border: { display: false },
          grid: {
            drawTicks: false,
          },
          position: 'right',
          ticks: {
            color: EARLY_UPGRADE_CHART_FONT_COLOR,
            font: CHART_FONT,
          },
        },
      },
    },
    type: 'bar',
  }

  return (
    <div className="DashboardEarlyUpgradeEligibleCard-chart">
      <Bar {...config} />
    </div>
  )
}
